import React, { useEffect } from 'react';

export default function useOnClickOutside(
  ref: React.RefObject<HTMLElement | null>,
  handler: (arg: any) => void,
  additionalRef: React.RefObject<HTMLElement | null>,
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (event.target instanceof Element) {
        if (
          !ref.current ||
          ref.current.contains(event.target) ||
          additionalRef?.current?.contains(event.target)
        ) {
          return;
        }
        handler(event);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, additionalRef]);
}
